
export type GetTweetFeed200TweetsItemStats = {
  likes?: number;
  replies?: number;
  retweets?: number;
  views?: number;
};
